"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidModifyOrganisationStep;
var REQUIRED_FIELDS = ['name'];

function isValidModifyOrganisationStep(organisation, step) {
  if (!step && step !== 0 || step === 1) {
    return true;
  }

  if (step > 4 || step < 1 || !organisation) {
    return false;
  }

  var requiredFields = REQUIRED_FIELDS.slice(0, step - 1);
  return requiredFields.every(function (field) {
    return organisation && organisation[field];
  });
}